import { useEffect, useState } from 'react'
import { MenuComponent } from '../../../../../../../_metronic/assets/ts/components'
import { initialQueryState, KTIcon } from '../../../../../../../_metronic/helpers'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'

const LogsListFilter = () => {
  const { updateState } = useQueryRequest()
  const { isLoading } = useQueryResponse()
  const [accion, setAccion] = useState<string | undefined>()
  const [modulo, setModulo] = useState<string | undefined>()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const resetData = () => {
    updateState({ filtro: undefined, ...initialQueryState })
  }

  const filterData = () => {
    updateState({
      filtro: { accion, modulo },
      ...initialQueryState,
    })
  }

  return (
    <>
      {/* begin::Filter Button */}
      <button disabled={isLoading} type='button' className='btn btn-light-primary me-3' data-kt-menu-trigger='click' data-kt-menu-placement='bottom-end'>
        <KTIcon iconName='filter' className='fs-2' />
        Filtrar
      </button>
      {/* end::Filter Button */}
      {/* begin::SubMenu */}
      <div className='menu menu-sub menu-sub-dropdown w-300px w-md-325px' data-kt-menu='true'>
        {/* begin::Header */}
        <div className='px-7 py-5'>
          <div className='fs-5 text-dark fw-bolder'>Filtrar</div>
        </div>
        {/* end::Header */}

        {/* begin::Separator */}
        <div className='separator border-gray-200'></div>
        {/* end::Separator */}

        {/* begin::Content */}
        <div className='px-7 py-5' data-kt-user-table-filter='form'>
          {/* begin::Input group */}
          <div className='mb-5'>
            <select
              className='form-select form-select-solid fw-bolder'
              data-kt-select2='true'
              data-placeholder='Estatus Usuario'
              data-allow-clear='true'
              data-kt-user-table-filter='Estatus'
              data-hide-search='true'
              onChange={(e) => setAccion(e.target.value)}
              value={accion}
            >
              <option hidden>Acción</option>
              <option value='actualizar'>Actualizar</option>
              <option value='borrar'>Borrar</option>
              <option value='cancelar'>Cancelar</option>
              <option value='crear'>Crear</option>
              <option value='Inicio de sesión'>Inicio de Sesión</option>
            </select>
          </div>
          {/* end::Input group */}
          <div className='mb-5'>
            <select
              className='form-select form-select-solid fw-bolder'
              data-kt-select2='true'
              data-placeholder='NombreTabla'
              data-allow-clear='true'
              data-kt-user-table-filter='nombreTabla'
              data-hide-search='true'
              onChange={(e) => setModulo(e.target.value)}
              value={modulo}
            >
              <option hidden>Módulo</option>
              <option value='DatosFiscales'>Datos Fiscales</option>
              <option value='Descuento'>Descuento</option>
              <option value='Paneles'>Paneles</option>
              <option value='Producto'>Producto</option>
              <option value='Sesión'>Sesión</option>
              <option value='Sucursal'>Sucursal</option>
              <option value='UsuariosGcTrack'>Usuarios GcTrack</option>
              <option value='UsuariosPanelTrack'>Usuarios PanelTrack</option>
            </select>
          </div>

          {/* begin::Actions */}
          <div className='d-flex justify-content-end'>
            <button
              type='button'
              disabled={isLoading}
              onClick={resetData}
              className='btn btn-light btn-active-light-primary fw-bold me-2 px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='reset'
            >
              Reestablecer
            </button>
            <button
              disabled={isLoading}
              type='button'
              onClick={filterData}
              className='btn btn-primary fw-bold px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='filter'
            >
              Aplicar
            </button>
          </div>
          {/* end::Actions */}
        </div>
        {/* end::Content */}
      </div>
      {/* end::SubMenu */}
    </>
  )
}

export { LogsListFilter }
